import { useQuery } from "react-query";
import axios from "axios";

const getEmailListsByCompanyId = async (companyId) => {
  const { data } = await axios.get(
    "/api/v2/companies/" + companyId + "/email_lists"
  );

  return data;
};

export default function useContactGroups({ companyId, enabled = true }) {
  return useQuery(
    ["companies", companyId, "email_lists"],
    () => {
      return getEmailListsByCompanyId(companyId);
    },
    {
      enabled: companyId !== undefined && companyId !== "" && enabled,
    }
  );
}
